var $526320975d72721b$exports = {};
$526320975d72721b$exports = {
    "clear": `Borrar`,
    "invalid": `(no v\xe1lido)`,
    "loading": `Cargando\u{2026}`,
    "noResults": `Sin resultados`,
    "valid": `(v\xe1lido)`
};


export {$526320975d72721b$exports as default};
//# sourceMappingURL=es-ES.mjs.map
